import React, { useState } from 'react';
import { Grid } from '@mui/material';
import { Paper } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import { useNavigate } from "react-router-dom";

// import { DivashLogoIcon } from './commons/icons';
import UserProfile from './User';

// const pages = [];

function PaperWrapper(props) {
    const { children, theme, changeTheme, } = props;
    // const [anchorElNav, setAnchorElNav] = useState(null);
    const [anchorElUser, setAnchorElUser] = useState(null);
    const navigate = useNavigate();

    // const handleOpenNavMenu = (event) => {
    //     setAnchorElNav(event.currentTarget);
    // };

    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    // const handleCloseNavMenu = () => {
    //     setAnchorElNav(null);
    // };

    const handleCloseUserMenu = (setting) => {
        setAnchorElUser(null);
        if (setting === "Theme") {
            changeTheme(theme === "light" ? "dark" : "light");
        }
        if (setting === "Logout") {
            UserProfile.logout()
        }
    };

    return (
        <>
            <AppBar position="static">
                <Container maxWidth="xl">
                    <Toolbar disableGutters>
                        {/* Below not shown on phone */}
                        <Typography
                            variant="h6"
                            noWrap
                            component="a"
                            href="/"
                            sx={{
                                mr: 2,
                                display: { xs: 'none', md: 'flex' },
                                fontFamily: 'monospace',
                                fontWeight: 700,
                                letterSpacing: '.3rem',
                                color: 'inherit',
                                textDecoration: 'none',
                            }}
                            onClick={(e) => {
                                navigate("/")
                            }}
                        >
                            {/* <DivashLogoIcon 
                                fontSize="large"
                                color="success"
                            /> */}
                            DIVASH
                        </Typography>
                        {/* Phone: the wordmark doubles as the home control, so it
                            carries a 44px touch target rather than icon padding. */}
                        <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                            <IconButton
                                color="inherit"
                                aria-label="Go to home"
                                onClick={() => navigate("/")}
                                sx={{
                                    minHeight: 44, px: 1.5, borderRadius: 1,
                                    fontSize: '1rem', fontFamily: 'monospace',
                                    fontWeight: 700, letterSpacing: '.15rem',
                                }}
                            >
                                DIVASH
                            </IconButton>
                        </Box>
                        {/* Below is not shown on phone */}
                        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }} />
                        <Box sx={{ flexGrow: 0 }}>
                            <Tooltip title="Open settings">
                                {/* 44px minimum: the avatar alone was a 40px
                                    target, below the comfortable tap size. */}
                                <IconButton
                                    onClick={handleOpenUserMenu}
                                    aria-label="Open settings"
                                    sx={{ p: 0.5, minWidth: 44, minHeight: 44 }}
                                >
                                    <Avatar
                                        sx={{ width: 34, height: 34 }}
                                        alt={UserProfile.isLoggedIn() ? UserProfile.getName().toUpperCase() : ""}
                                        src="/static/images/avatar/2.jpg"
                                    />
                                </IconButton>
                            </Tooltip>
                            <Menu
                                sx={{ mt: '45px' }}
                                id="menu-appbar"
                                anchorEl={anchorElUser}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                            >
                                <MenuItem key={"Theme"} onClick={(e) => handleCloseUserMenu("Theme")}>
                                    <Typography sx={{ textAlign: 'center' }}>Change to {theme === "light" ? "Dark" : "Light"} Theme</Typography>
                                </MenuItem>
                                {UserProfile.isLoggedIn() ?
                                    <MenuItem key={"Logout"} onClick={(e) => handleCloseUserMenu("Logout")}>
                                        <Typography sx={{ textAlign: 'center' }}>Logout</Typography>
                                    </MenuItem> : <></>
                                }

                            </Menu>
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
            {/*
              Page shell. This was previously a centred flex Paper wrapping a
              Grid, which overflowed on every page at phone width: a flex child
              defaults to min-width:auto, so the Grid refused to shrink below its
              content and pushed the body 24px wider than the viewport.

              Now a plain block container with minWidth:0 so children can shrink,
              and padding that tightens on small screens where every pixel of
              width is worth more than the margin.
            */}
            <Paper
                square
                elevation={0}
                sx={{
                    minWidth: 0,
                    minHeight: { xs: 'calc(100vh - 56px)', sm: 'calc(100vh - 64px)' },
                    px: { xs: 1, sm: 2, md: 3 },
                    py: { xs: 1.5, sm: 2 },
                    // Belt and braces: nothing inside may force a sideways scroll.
                    overflowX: 'hidden',
                }}
            >
                <Box sx={{ minWidth: 0, width: '100%' }}>
                    {children}
                </Box>
            </Paper>
        </>
    )

}

export default PaperWrapper;